<template>
  <div class="overflow-auto">
    <div class="header">
      <b-pagination
        v-model="currentPage"
        :total-rows="filteredSize"
        :per-page="perPage"
        aria-controls="my-table"
        align="fill"
        :limit="limit"
      ></b-pagination>
    </div>

    <b-table
      ref="selectableTable"
      :selectable="selectable"
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      @row-selected="onRowSelected"
      responsive="sm"
      :per-page="perPage"
      :current-page="currentPage"
      @context-changed="onPaginate"
      :busy="isBusy"
      thead-tr-class="org-thead"
      :filter-function="filterItems"
      :filter="filter"
      @filtered="onFilter"
      :class="tableClass"
      striped
    >
      <template v-slot:head()="data">
        <i>{{data.label}}</i>
        <template v-if="data.field.filterType == 'string'">
          <div :class="{ filter:true, 'filter-on':filter[data.column], 'filter-off':!filter[data.column] }" 
            @click="onOpenFilter(data.column)"></div>
          <div v-if="filter[data.column]">
            <v-select
              v-model="filter[data.column]"
              multiple
              taggable
              :noDrop="true"
            >
            </v-select>
          </div>
        </template>
      </template>

      <!-- b-table.cell(~)を全て子に引き継ぐ -->
      <template v-for="field in fields" 
        v-slot:[cellName(field.key)]="row">
        <slot v-if="field.key !== 'selected'" 
          :name="cellName(field.key)" 
          :item="row.item"
          :toggleDetails="row.toggleDetails"
          :detailsShowing="row.detailsShowing"
          :index="row.index">
          {{ row.item[field.key] }}
        </slot>
      </template>

      <template v-slot:cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    <template v-slot:row-details="row">
      <slot
        name="row-details" 
        :item="row.item"
        :toggleDetails="row.toggleDetails"
        :detailsShowing="row.detailsShowing"
        :index="row.index">
      </slot>
    </template>

    </b-table>

  </div>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'
  export default {
    name: 'select-list',
    props: {
      items: {
        type: Array,
        default: () => []
      },
      perPage: {
        type: Number,
        default: 3
      },
      fields: Array,
      rows: {
        type: Number,
        default: 0
      },
      tableKey: {
        type: String,
        default: 'id'
      },
      selectable: {
        type: Boolean,
        default: true
      },
      tableClass: String,
      limit: {
        type: Number,
        default: 5
      }
    },
    data() {
      return {
        currentPage: 1,
        selectMode: 'multi',
        itemMap: {},
        selected: {},
        la: false,
        isBusy: false,
        filter: {},
        filteredSize: 0,
      }
    },
    computed: {
      totalRows () {
        return this.rows || this.items.length
      },
      previewData () {
        let index = this.$refs.selectableTable.selectedLastClicked
        if(index > -1){
          return this.items[index]
        }else{
          return {}
        }
      }
    },
    methods: {
      cellName (name) {
        return 'cell(' + name + ')'
      },
      merge(page, selected){
        page.forEach((elm, i) => {
          this.itemMap[elm[this.tableKey]].selected = selected[i]
          if(selected[i]){
            this.selected[elm[this.tableKey]] = elm
          }else{
            delete this.selected[elm[this.tableKey]];
          }
        })
      },
      onRowSelected () {
        // this.log()
        if(this.la){
          this.sync()
          this.la = false
        }
        this.merge(this.$refs.selectableTable.computedItems,
          this.$refs.selectableTable.selectedRows)
      },
      onPaginate () {
        this.la = true //ページやフィルタが切り替わった直後はマージしない
      },
      onOpenFilter (key) {
        if(this.filter[key]){
          Vue.delete(this.filter, key)
        }else{
          Vue.set(this.filter, key, [])
        }
      },
      onFilter (items) {
        this.filteredSize = items.length
      },
      filterItems (row, filter) {
        let empty = true
        for (const key in filter) {
          let field = _.find(this.fields, { key })
          let filterValue
          if(!field.filterKey && row.hasOwnProperty(key)){
            filterValue = row[key]
          }else if(_.isString(field.filterKey) 
                && row.hasOwnProperty(field.filterKey)){
            filterValue = row[field.filterKey]
          }else if(_.isFunction(field.filterKey)){
            filterValue = field.filterKey.call(this, row)
          }
          if(filterValue) {
            let f = filter[key]
            f.forEach((val)=>{
              if(filterValue.indexOf(val) > -1){
                return true
              }
              empty = false
            })
          }
        }
        return empty
      },
      /** this.selectedからselectableTableにチェックを入れなおす */
      sync () {
        this.$refs.selectableTable.computedItems.forEach((elm, i)=>{
          if(elm.selected){
            this.$refs.selectableTable.selectRow(i)
          }
        })
      },
      mappingItems (newVal) {
        let src = newVal || this.items
        this.itemMap = {}
        src.forEach((elm) => {
          this.itemMap[elm[this.tableKey]] = elm
        })
      },
      log () {
        let ary = []
        this.items.forEach((elm)=>{ary.push(elm.selected)})
      }
    },
    mounted () {
      this.$watch(() => this.$refs.selectableTable.computedItems, ()=>{
        this.sync()
      })
      this.$watch('items', (newVal) => {
        this.mappingItems(newVal)
        this.filteredSize = this.totalRows
      })
      this.mappingItems()
      this.filteredSize = this.totalRows
      this.sync()
    }
  }
</script>

<style lang="scss" scoped>
.cont {
  margin: 0;
}
.filter {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 5px;

  &.filter-on {
    background-image: url("data:image/svg+xml;utf8,<svg version='1.1' id='_x32_' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='width: 16px; height: 16px; opacity: 1;' xml:space='preserve'><g><polygon class='st0' points='0,27.435 211.912,255.993 211.912,484.565 300.076,457.137 300.076,255.993 512,27.435 	' style='fill: rgb(75, 75, 75);'></polygon></g></svg>")
  }
  &.filter-off {
    background-image: url("data:image/svg+xml;utf8,<svg version='1.1' id='_x32_' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='width: 16px; height: 16px; opacity: 1;' xml:space='preserve'><g><polygon class='st0' points='0,27.435 211.912,255.993 211.912,484.565 300.076,457.137 300.076,255.993 512,27.435 	' style='fill: rgb(205, 205, 205);'></polygon></g></svg>");
  }
}
.sort-none {
  display: inline-block;
  background: url("data:image/svg+xml;utf8,data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='21' height='21'><path fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/></svg>");
  width: 20px;
  height: 20px;
  margin: 0;
}
.sort-ascending {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}
.sort-descending {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}
.overflow-auto {
  ::v-deep .org-thead th{
    vertical-align: top;
  }
}

</style>